/* ASTREK Lab — vanilla JS + GSAP port of components/QuizBoard.tsx + QuizModal.tsx.
   Endless pan/zoom canvas of question cards; clicking one opens the quiz. */
(function () {
  'use strict';

  /* Scattered arrangement echoing the design's exploration board — one slot
     per question. Every card is the same size; only the spacing is uneven —
     some cards cluster into tight pairs while large gaps open elsewhere, so
     no rows or columns read through. The slot set still repeats per tile,
     keeping the endless canvas seamless. */
  var BOARD_CARD_W = 5.5;
  var BOARD_SLOTS = [
    { top: 4, left: 6 },
    { top: 16, left: 16.5 },
    { top: 7, left: 28 },
    { top: 2, left: 58 },
    { top: 9, left: 76 },
    { top: 14, left: 89.5 },
    { top: 32, left: 3 },
    { top: 28, left: 38 },
    { top: 41, left: 48 },
    { top: 30, left: 68 },
    { top: 47, left: 15 },
    { top: 52, left: 30 },
    { top: 55, left: 58 },
    { top: 44, left: 86.5 },
    { top: 66, left: 6 },
    { top: 72, left: 17 },
    { top: 67, left: 27.5 },
    { top: 78, left: 44 },
    { top: 63, left: 75 },
    { top: 80, left: 62 },
    { top: 88, left: 10 },
    { top: 87, left: 30 },
    { top: 74, left: 90 },
    { top: 89, left: 74 }
  ];

  /* Deck stack slots: the front card, then two cards peeking top-right. */
  var DECK_SLOTS = [
    { xPercent: 0, yPercent: 0, rotate: 0, scale: 1, zIndex: 30 },
    { xPercent: 9, yPercent: -7, rotate: 3, scale: 0.97, zIndex: 20 },
    { xPercent: 18, yPercent: -14, rotate: 6, scale: 0.94, zIndex: 10 }
  ];

  var CLOSE_SVG =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path d="M4 4l16 16M20 4L4 20" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  var ARROW_SVG =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var DISCORD_SVG =
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
    '<path d="M20.32 4.37a19.8 19.8 0 0 0-4.93-1.51 13.78 13.78 0 0 0-.64 1.28 18.27 18.27 0 0 0-5.5 0 12.64 12.64 0 0 0-.64-1.28 19.74 19.74 0 0 0-4.93 1.51C.53 9.05-.32 13.58.1 18.06a19.9 19.9 0 0 0 6.07 3.03c.49-.66.93-1.37 1.3-2.1a12.9 12.9 0 0 1-2.05-.98c.17-.12.34-.25.5-.38a14.2 14.2 0 0 0 12.16 0c.17.13.33.26.5.38-.65.39-1.34.71-2.05.98.38.73.81 1.44 1.3 2.1a19.84 19.84 0 0 0 6.07-3.03c.5-5.18-.84-9.67-3.58-13.69ZM8.02 15.33c-1.18 0-2.16-1.08-2.16-2.42 0-1.33.95-2.42 2.16-2.42 1.21 0 2.18 1.09 2.16 2.42 0 1.34-.95 2.42-2.16 2.42Zm7.96 0c-1.18 0-2.16-1.08-2.16-2.42 0-1.33.95-2.42 2.16-2.42 1.21 0 2.18 1.09 2.16 2.42 0 1.34-.95 2.42-2.16 2.42Z"/></svg>';

  /* share platforms (result screen → "Share on …") — the Figma glyphs,
     copied verbatim from components/icons.tsx (26×30 / 26×26 / 26×25) */
  var TIKTOK_SVG =
    '<svg aria-hidden="true" width="26" height="30" viewBox="0 0 26 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.2691 10.6063C21.1661 11.9617 23.4901 12.7591 26.0001 12.7591V7.93161C25.5251 7.93171 25.0513 7.8822 24.5865 7.78379V11.5837C22.0768 11.5837 19.7531 10.7863 17.8556 9.43098V19.2825C17.8556 24.2108 13.8584 28.2057 8.92797 28.2057C7.08831 28.2057 5.37842 27.6498 3.95801 26.6964C5.57917 28.3532 7.84001 29.381 10.3412 29.381C15.272 29.381 19.2693 25.3861 19.2693 20.4576V10.6063H19.2691ZM21.0129 5.7359C20.0434 4.67727 19.4068 3.30918 19.2691 1.7967V1.17578H17.9296C18.2667 3.09814 19.4168 4.74049 21.0129 5.7359ZM7.07651 22.9146C6.53485 22.2048 6.24213 21.3364 6.24345 20.4435C6.24345 18.1895 8.07172 16.362 10.3273 16.362C10.7477 16.3619 11.1655 16.4262 11.5661 16.5532V11.6178C11.098 11.5537 10.6255 11.5265 10.1532 11.5364V15.3779C9.75227 15.2509 9.33422 15.1864 8.91376 15.1868C6.65816 15.1868 4.83 17.0141 4.83 19.2684C4.83 20.8624 5.74383 22.2424 7.07651 22.9146Z" fill="#FF004F"/><path d="M17.8556 9.43088C19.7531 10.7862 22.0768 11.5836 24.5866 11.5836V7.78369C23.1856 7.48543 21.9454 6.75369 21.0129 5.7359C19.4168 4.74039 18.2668 3.09804 17.9296 1.17578H14.411V20.4574C14.403 22.7053 12.5779 24.5254 10.3271 24.5254C9.00081 24.5254 7.8225 23.8935 7.07625 22.9146C5.74367 22.2424 4.82983 20.8623 4.82983 19.2685C4.82983 17.0144 6.658 15.1869 8.91359 15.1869C9.34576 15.1869 9.76229 15.2541 10.153 15.378V11.5365C5.30918 11.6366 1.41357 15.5924 1.41357 20.4575C1.41357 22.8862 2.38367 25.0878 3.95815 26.6965C5.37856 27.6498 7.08845 28.2058 8.92811 28.2058C13.8587 28.2058 17.8557 24.2107 17.8557 19.2825V9.43088H17.8556Z" fill="black"/><path d="M24.5865 7.7831V6.75563C23.3231 6.75754 22.0846 6.40393 21.0128 5.73521C21.9616 6.77348 23.211 7.48938 24.5865 7.7831ZM17.9295 1.17519C17.8973 0.991479 17.8726 0.806553 17.8555 0.620922V0H12.9972V19.2819C12.9895 21.5294 11.1644 23.3495 8.91347 23.3495C8.25262 23.3495 7.62868 23.1927 7.07613 22.9141C7.82238 23.8929 9.00069 24.5247 10.327 24.5247C12.5776 24.5247 14.403 22.7048 14.4109 20.457V1.17519H17.9295ZM10.1531 11.536V10.4421C9.74714 10.3867 9.33787 10.3589 8.92809 10.3591C3.99715 10.359 0 14.354 0 19.2819C0 22.3713 1.57095 25.0941 3.95813 26.6957C2.38365 25.0872 1.41355 22.8854 1.41355 20.4569C1.41355 15.5918 5.30906 11.636 10.1531 11.536Z" fill="#00F2EA"/></svg>';
  var INSTAGRAM_SVG =
    '<svg aria-hidden="true" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.0402813 6.0604C0.039035 6.03195 0.0385157 6.00346 0.0387234 5.97498C0.0561723 4.35517 0.579145 2.80227 1.75248 1.65065C2.48543 0.942481 3.39784 0.447876 4.39128 0.220189C5.31352 0.00177464 6.39847 0.00610568 7.34058 0.00423357L9.57429 0.00254582L16.088 0.00458411C16.9314 -0.00180394 17.7748 -0.00151545 18.6181 0.00544877C20.7688 0.0170917 22.5786 0.039513 24.256 1.65254C24.8122 2.18736 25.378 3.02041 25.5922 3.76546C26.0902 5.0075 25.99 7.0269 25.9947 8.38136L25.9996 13.3706L25.9944 17.8413C25.9931 18.291 25.9851 18.7435 25.9874 19.193C25.9929 20.323 25.936 21.4744 25.4761 22.526C25.042 23.5418 24.3326 24.4124 23.3953 25.0078C23.3844 25.0148 23.3685 25.0176 23.3558 25.0206C23.1925 25.1509 22.8822 25.3068 22.6903 25.3925C21.5299 25.9107 20.3028 25.9694 19.0577 25.977C18.2676 26.0089 17.3061 25.9837 16.5056 25.9837L11.6952 25.9845L8.03043 25.9808C6.79325 25.977 4.47972 26.0263 3.39638 25.4093C2.81867 25.2035 2.06734 24.6488 1.6456 24.2092C0.0470327 22.5431 -0.0114676 20.6163 0.0186264 18.471C0.0108627 18.267 0.0137969 18.0525 0.0149394 17.8475C0.0241312 16.213 -0.00819648 14.573 0.0151985 12.9392C0.00411119 12.5769 0.00299454 12.1911 0.0100312 11.8291C0.047162 9.92091 -0.0512473 7.96254 0.0402813 6.0604Z" fill="white"/><path d="M16.0882 0.00458411C16.9316 -0.00180394 17.7749 -0.00151545 18.6183 0.00544877C20.769 0.0170917 22.5788 0.039513 24.2562 1.65254C24.8124 2.18736 25.3782 3.02041 25.5924 3.76546C26.0904 5.0075 25.9902 7.0269 25.9949 8.38136L25.9998 13.3706L25.9946 17.8413C25.9933 18.291 25.9853 18.7435 25.9876 19.193C25.993 20.323 25.9362 21.4744 25.4763 22.526C25.0422 23.5418 24.3328 24.4124 23.3955 25.0078C23.3845 25.0148 23.3687 25.0176 23.356 25.0206C23.1927 25.1509 22.8824 25.3068 22.6905 25.3925C21.5301 25.9107 20.303 25.9694 19.0579 25.977C18.293 25.9424 17.4075 25.9673 16.6247 25.9497C16.6735 25.9032 17.0578 25.9042 17.1513 25.9011C17.1432 25.8069 17.0944 25.8186 17.091 25.796C16.9357 24.8382 16.4107 24.0796 15.7811 23.3693C15.7058 23.2845 15.3524 22.8454 15.3202 22.7691C15.4103 22.6666 15.7003 22.6831 15.893 22.6254C18.4062 22.5729 20.2204 22.3389 21.7627 20.1281C21.7921 20.0312 21.9598 19.7356 22.0159 19.6174C22.6624 18.2528 22.6406 16.6235 22.6565 15.1331C22.6669 14.2157 22.6705 13.2982 22.6674 12.3808C22.6617 11.2114 22.6601 10.0507 22.5952 8.88214C22.5217 7.56077 22.2439 6.53796 21.4771 5.44352C21.3211 5.26472 21.1622 5.08929 20.996 4.91995C19.3962 3.29094 16.9921 3.35752 14.8598 3.34781L12.4102 3.34186C12.6756 3.30016 13.5295 3.31351 13.8375 3.31278C13.5945 3.27217 12.3133 3.26589 12.0728 3.28232C12.2711 3.19648 12.5052 3.19581 12.692 3.08763C12.8135 3.01729 12.8891 2.88412 13.0268 2.80695C13.29 2.65949 13.5347 2.47267 13.7865 2.30655C14.3012 1.96697 16.0602 0.865478 16.2064 0.305416C16.2264 0.228924 16.2061 0.187901 16.1677 0.123036C16.0277 0.021415 15.8465 0.045202 15.6723 0.0462614L16.0882 0.00458411Z" fill="#FE0480"/><path d="M16.0882 0.00458411C16.9316 -0.00180394 17.7749 -0.00151545 18.6183 0.00544877C20.769 0.0170917 22.5788 0.039513 24.2562 1.65254C24.8124 2.18736 25.3782 3.02041 25.5924 3.76546C25.5869 3.76263 25.541 3.73955 25.5405 3.73838C25.3117 3.18519 25.0518 2.6335 24.6582 2.17649C24.5673 2.07113 24.4603 1.99735 24.3445 1.91982C23.5736 2.26617 22.5723 2.2889 21.7363 2.6322C21.0269 2.92351 19.9239 3.10469 19.4739 3.82246C19.6393 3.93572 19.8605 4.04657 20.0376 4.12444C20.3401 4.25741 21.4602 5.15257 21.4771 5.44351C21.3211 5.26472 21.1622 5.08929 20.996 4.91995C19.3962 3.29094 16.9921 3.35752 14.8598 3.34781L12.4102 3.34186C12.6756 3.30016 13.5295 3.31351 13.8375 3.31278C13.5945 3.27217 12.3133 3.26589 12.0728 3.28232C12.2711 3.19648 12.5052 3.19581 12.692 3.08763C12.8135 3.01729 12.8891 2.88412 13.0268 2.80695C13.29 2.65949 13.5347 2.47267 13.7865 2.30655C14.3012 1.96697 16.0602 0.865477 16.2064 0.305416C16.2264 0.228924 16.2061 0.187901 16.1677 0.123036C16.0277 0.021415 15.8465 0.045202 15.6723 0.0462614L16.0882 0.00458411Z" fill="#FB00D3"/><path d="M21.7624 20.1289C21.764 20.5587 20.5737 21.4315 20.542 21.6168C20.7266 21.9906 20.998 22.3313 21.1922 22.6957C21.5684 23.4016 21.8587 24.1756 22.0862 24.9417C22.1314 25.0944 22.2615 25.4029 22.1727 25.5353L22.2074 25.5527C22.3547 25.4766 23.2217 25.0441 23.3556 25.0214C23.1923 25.1517 22.882 25.3077 22.6901 25.3933C21.5297 25.9116 20.3026 25.9702 19.0576 25.9778C18.2926 25.9432 17.4072 25.9682 16.6243 25.9505C16.6731 25.904 17.0574 25.9051 17.1509 25.902C17.1429 25.8077 17.094 25.8194 17.0907 25.7968C16.9354 24.8391 16.4104 24.0805 15.7807 23.3701C15.7054 23.2854 15.352 22.8462 15.3198 22.7699C15.4099 22.6675 15.7 22.6839 15.8926 22.6262C18.4058 22.5737 20.22 22.3397 21.7624 20.1289Z" fill="#FF7211"/><path d="M0.0401766 6.05981C0.0389303 6.03135 0.038411 6.00287 0.0386187 5.97438C0.0560676 4.35458 0.57904 2.80168 1.75237 1.65005C2.48533 0.941888 3.39773 0.447283 4.39117 0.219596C5.31342 0.00118194 6.39836 0.00551299 7.34047 0.00364088L9.57419 0.00195312L16.0879 0.00399142L15.672 0.0456687C15.8462 0.0446093 16.0274 0.0208223 16.1674 0.122444C16.2058 0.187308 16.2261 0.228331 16.2061 0.304823C16.0599 0.864885 14.3009 1.96638 13.7862 2.30596C13.5344 2.47207 13.2898 2.65889 13.0265 2.80635C12.8888 2.88352 12.8132 3.0167 12.6917 3.08704C12.5049 3.19521 12.2708 3.19589 12.0725 3.28173C12.313 3.26529 13.5943 3.27158 13.8372 3.31219C13.5292 3.31292 12.6754 3.29957 12.4099 3.34127C10.0247 3.35186 6.95099 3.0807 5.10832 4.83359C4.96911 4.96599 4.8323 5.11934 4.69204 5.24514C4.72795 4.9752 5.27307 4.67948 5.26938 4.52096C5.1227 4.45963 4.65719 4.64233 4.48649 4.68322L3.14459 4.99255C2.92877 5.04368 2.29949 5.20316 2.11812 5.2299C1.94493 5.25548 0.146818 5.49568 0.161332 5.50134C0.13708 5.44105 0.136015 5.42882 0.130147 5.36388C0.121449 5.51765 0.115217 5.96057 0.0401766 6.05981Z" fill="#B905EC"/><path d="M0.244435 12.5638C0.8351 12.2592 1.90454 11.9835 2.57056 11.8133C2.75362 11.7665 3.07504 11.7733 3.24169 11.7192C3.29754 11.6252 3.30689 11.4809 3.32239 11.3691C3.32211 11.6231 3.31112 11.9924 3.3402 12.2359C3.36298 12.7358 3.3469 13.3369 3.34864 13.8454C3.35243 14.9629 3.35288 16.0374 3.41919 17.1538C3.61386 19.2304 4.16329 20.6943 6.02354 21.8276C5.90534 21.8653 5.85131 21.7626 5.83596 21.7799C5.74412 21.8837 5.53266 22.0592 5.43207 22.1399C5.09137 22.4131 4.70171 22.6271 4.35902 22.8887C3.8577 23.2714 3.3938 23.7664 2.95508 24.2234C2.82977 24.3539 2.67201 24.6934 2.5394 24.816C2.51107 24.8152 2.48643 24.8145 2.46545 24.814C2.55272 24.9866 3.28822 25.232 3.39621 25.4096C2.8185 25.2038 2.06717 24.6491 1.64543 24.2095C0.0468633 22.5434 -0.0116371 20.6166 0.018457 18.4713C0.0106933 18.2673 0.0136274 18.0528 0.0147699 17.8478C0.0239617 16.2133 -0.00836594 14.5733 0.015029 12.9395C0.0243507 12.8267 0.0294401 12.7589 0.05512 12.6494L0.124292 12.7155C0.193594 12.6888 0.198892 12.6433 0.244435 12.5638Z" fill="#FF8002"/><path d="M0.244435 12.5638C0.8351 12.2592 1.90454 11.9835 2.57056 11.8133C2.75362 11.7665 3.07504 11.7733 3.24169 11.7192C3.29754 11.6252 3.30689 11.4809 3.32239 11.3691C3.32211 11.6231 3.31112 11.9924 3.3402 12.2359C3.36298 12.7358 3.3469 13.3369 3.34864 13.8454C3.35243 14.9629 3.35288 16.0374 3.41919 17.1538C3.41278 17.2274 3.41408 17.3106 3.3783 17.3716C3.41467 17.4399 3.40847 17.5216 3.41034 17.597L3.39416 17.6115L3.34363 17.5129L3.3012 17.5084C3.27088 17.5616 3.24421 17.6083 3.2104 17.6599L3.18119 17.6485L3.1659 17.6669C2.91639 17.963 1.97891 18.3203 1.5875 18.5329C1.20223 18.7422 0.537586 19.1456 0.125383 19.1977C0.0262721 19.0954 0.0995994 18.5482 0.018457 18.4713C0.0106933 18.2673 0.0136274 18.0528 0.0147699 17.8478C0.0239617 16.2133 -0.00836594 14.5733 0.015029 12.9395C0.0243507 12.8267 0.0294401 12.7589 0.05512 12.6494L0.124292 12.7155C0.193594 12.6888 0.198892 12.6433 0.244435 12.5638Z" fill="#FF2733"/><path d="M3.39658 25.409C3.28859 25.2314 2.55309 24.986 2.46582 24.8134C2.4868 24.8139 2.51144 24.8146 2.53977 24.8154C2.67238 24.6928 2.83014 24.3533 2.95545 24.2228C3.39417 23.7658 3.85807 23.2708 4.35939 22.8881C4.70208 22.6265 5.09174 22.4125 5.43244 22.1393C5.53303 22.0586 5.74449 21.8831 5.83633 21.7793C5.85168 21.762 5.90571 21.8647 6.02391 21.827C6.56056 22.0956 7.07832 22.3101 7.67314 22.4182C8.94566 22.6495 10.3527 22.6367 11.6431 22.6395C13.0598 22.6459 14.4765 22.6412 15.893 22.6251C15.7003 22.6828 15.4103 22.6664 15.3202 22.7688C15.3524 22.8451 15.7058 23.2843 15.7811 23.369C16.4107 24.0794 16.9358 24.838 17.091 25.7957C17.0944 25.8183 17.1432 25.8066 17.1513 25.9009C17.0578 25.904 16.6735 25.9029 16.6247 25.9494C17.4075 25.9671 18.293 25.9421 19.0579 25.9767C18.2678 26.0086 17.3063 25.9834 16.5058 25.9834L11.6954 25.9842L8.03063 25.9806C6.79345 25.9767 4.47992 26.026 3.39658 25.409Z" fill="#FFBD01"/><path d="M0.0402813 6.06108C0.115322 5.96184 0.121553 5.51892 0.130252 5.36516C0.13612 5.4301 0.137185 5.44233 0.161437 5.50262C0.146922 5.49696 1.94504 5.25675 2.11823 5.23117C2.2996 5.20443 2.92887 5.04495 3.1447 4.99382L4.4866 4.68449C4.65729 4.6436 5.12281 4.46091 5.26948 4.52224C5.27317 4.68076 4.72805 4.97648 4.69214 5.24642C4.47312 5.61946 4.21975 5.8712 4.01582 6.30189C3.31573 7.78045 3.39179 9.44518 3.35585 11.041C3.34892 11.3313 3.36901 11.9859 3.34037 12.2363C3.31129 11.9928 3.32228 11.6234 3.32256 11.3695C3.30706 11.4813 3.29771 11.6256 3.24186 11.7196C3.07521 11.7737 2.75379 11.7669 2.57073 11.8137C1.90471 11.9838 0.835269 12.2596 0.244605 12.5641C0.199061 12.6437 0.193764 12.6892 0.124462 12.7159L0.0552895 12.6497C0.0296095 12.7593 0.0245201 12.8271 0.0151985 12.9399C0.00411119 12.5775 0.00299454 12.1918 0.0100312 11.8297C0.047162 9.92159 -0.0512473 7.96322 0.0402813 6.06108Z" fill="#F502C1"/><path d="M5.09908 11.676C5.05237 11.3502 5.09711 10.55 5.10568 10.1923C5.14063 8.73084 5.13304 7.12518 6.31736 6.07103C6.98418 5.47749 7.80765 5.23811 8.68809 5.1606C10.2471 5.04513 11.8506 5.07458 13.4158 5.0784L15.5016 5.08761C16.3437 5.09411 17.1219 5.12023 17.9559 5.25177C19.4112 5.48141 20.6241 6.66627 20.7659 8.16448C20.9154 8.59283 20.9201 11.5001 20.9209 12.1193L20.9191 14.8679C20.9149 15.8036 20.9011 16.7811 20.7911 17.7071C20.7033 18.4459 20.3377 19.2993 19.789 19.8114C19.7366 19.8606 19.6457 19.9495 19.5868 19.9812C18.7964 20.7217 17.3854 20.845 16.3419 20.8592C16.3291 20.8583 16.3164 20.8574 16.3037 20.8565C16.1121 20.8824 15.7034 20.8783 15.4946 20.8809L13.9719 20.8925C12.8901 20.8966 11.8083 20.8934 10.7265 20.883C9.43426 20.8671 7.7969 20.9148 6.6856 20.1812C5.98282 19.7174 5.49347 18.993 5.32553 18.1679C5.03541 17.3833 5.07571 12.7591 5.09908 11.676Z" fill="white"/><path d="M17.4925 10.8855L17.5281 10.8495C17.452 10.3831 16.3877 9.19751 15.9432 8.92253C15.7967 8.83197 15.6204 8.71419 15.4727 8.61097L15.4815 8.57379C15.5347 8.57029 15.536 8.56933 15.5872 8.55273C15.5731 8.529 15.5313 8.47603 15.5456 8.45238C15.9712 7.74928 16.5816 7.18357 17.2757 6.74709C17.4146 6.65982 17.5517 6.57463 17.6813 6.48408C17.6662 6.43228 17.6688 6.42415 17.6714 6.36934C17.7774 6.27675 17.7272 6.4073 17.8984 6.26935C18.0814 6.12176 18.2393 5.96747 18.4332 5.83497C18.4979 5.86184 18.5062 5.86351 18.5761 5.86135C18.7794 5.74567 18.595 5.45294 18.9868 5.64659C19.8785 6.08723 20.4349 6.92028 20.6629 7.8689C20.6907 7.98424 20.6736 8.07297 20.7657 8.164C20.9153 8.59236 20.92 11.4996 20.9208 12.1188L20.9189 14.8674C20.9148 15.8031 20.901 16.7806 20.7909 17.7066C20.7032 18.4454 20.3376 19.2988 19.7889 19.8109C19.7365 19.8601 19.6456 19.949 19.5866 19.9807C19.3831 19.99 19.2519 20.2319 19.0344 20.2819C18.9845 20.2933 18.8879 20.3684 18.8316 20.3963C18.433 19.4663 17.3157 18.6533 16.5025 18.0985C16.3355 17.9845 15.5197 17.5387 15.5282 17.3558C15.7601 17.1014 16.6325 16.6582 16.6728 16.3203C18.0181 14.8402 18.3413 12.6964 17.4925 10.8855Z" fill="#FE0480"/><path d="M19.1167 8.49049C19.1219 8.70956 18.7436 8.9203 18.5621 8.98301C18.2435 9.09546 17.8929 9.07248 17.5917 8.91944C17.3152 8.77905 17.1075 8.53276 17.0156 8.23668C16.9229 7.94275 16.9481 7.37691 17.0839 7.09609C17.1854 6.88637 17.4445 6.70962 17.666 6.64289C17.8192 6.79047 18.2656 6.38232 18.8789 6.84848C19.1619 7.06457 19.3452 7.38613 19.3873 7.73975C19.4067 7.90899 19.3722 8.08117 19.2637 8.21565L19.2481 8.23468C19.2151 8.32509 19.171 8.41104 19.1167 8.49049Z" fill="white"/><path d="M19.1167 8.49049C19.1219 8.70956 18.7436 8.9203 18.5621 8.98301C18.2435 9.09546 17.8929 9.07248 17.5917 8.91944C17.3152 8.77905 17.1075 8.53276 17.0156 8.23668C16.9229 7.94275 16.9481 7.37691 17.0839 7.09609C17.1854 6.88637 17.4445 6.70962 17.666 6.64289C17.8192 6.79047 18.2656 6.38232 18.8789 6.84848C19.1619 7.06457 19.3452 7.38613 19.3873 7.73975C19.4067 7.90899 19.3722 8.08117 19.2637 8.21565L19.2481 8.23468C19.4568 7.66193 19.1845 7.02549 18.626 6.78128C18.0672 6.5371 17.4152 6.76931 17.1366 7.3116C16.858 7.85389 17.0491 8.51931 17.5728 8.83119C18.0968 9.14306 18.7727 8.99386 19.1167 8.49049Z" fill="#FB00D3"/><path d="M5.09908 11.676C5.05237 11.3502 5.09711 10.55 5.10568 10.1923C5.14063 8.73084 5.13304 7.12518 6.31736 6.07103C6.98418 5.47749 7.80765 5.23811 8.68809 5.1606C10.2471 5.04513 11.8506 5.07458 13.4158 5.0784L15.5016 5.08761C16.3437 5.09411 17.1219 5.12023 17.9559 5.25177C19.4112 5.48141 20.6241 6.66627 20.7659 8.16448C20.6737 8.07345 20.6908 7.98472 20.663 7.86938C20.4351 6.92076 19.8786 6.0877 18.987 5.64707C18.5951 5.45342 18.7795 5.74615 18.5762 5.86183C18.5063 5.86398 18.498 5.86232 18.4334 5.83545C18.2394 5.96795 18.0815 6.12224 17.8985 6.26983C17.7274 6.40778 17.7775 6.27723 17.6716 6.36982C17.669 6.42463 17.6664 6.43276 17.6814 6.48456C17.5519 6.5751 17.4148 6.6603 17.2758 6.74757C16.5818 7.18405 15.9713 7.74976 15.5458 8.45285C15.5315 8.47651 15.5733 8.52948 15.5873 8.55321C15.5361 8.5698 15.5348 8.57076 15.4816 8.57427L15.4728 8.61145C15.6205 8.71466 15.7968 8.83244 15.9433 8.92301C16.3878 9.19799 17.4521 10.3835 17.5282 10.85L17.4927 10.8859C16.5857 8.95145 14.541 7.81613 12.4196 8.06927C10.2982 8.3224 8.57802 9.90698 8.1519 12.0005C8.05061 12.0101 8.02054 11.9314 7.9319 11.9336C7.43834 11.946 5.59167 11.8045 5.27762 12.0889L5.23371 12.1291L5.17783 12.1209C5.1345 12.0449 5.11614 11.7874 5.09908 11.676Z" fill="#FD01C0"/><path d="M16.6731 16.3203C16.6328 16.6582 15.7604 17.1014 15.5285 17.3558C15.5199 17.5387 16.3358 17.9845 16.5027 18.0985C17.316 18.6533 18.4333 19.4663 18.8319 20.3963C18.8882 20.3684 18.9848 20.2933 19.0346 20.2819C19.2522 20.2319 19.3834 19.99 19.5869 19.9807C18.7965 20.7212 17.3856 20.8445 16.342 20.8587C16.3293 20.8578 16.3166 20.8569 16.3038 20.856C16.1122 20.8819 15.7035 20.8778 15.4948 20.8804L13.9721 20.892C12.8903 20.8961 11.8084 20.8929 10.7266 20.8825C9.43442 20.8666 7.79706 20.9143 6.68576 20.1807C5.98298 19.7169 5.49363 18.9925 5.32568 18.1674C5.41233 18.2576 5.46894 18.4315 5.50469 18.5531C5.57955 18.5065 5.62444 18.5165 5.7013 18.4813C6.16658 18.2685 6.66052 18.1814 7.16085 18.1026C7.41773 18.0584 7.65451 17.9922 7.91416 17.9547C8.82426 17.8235 9.77361 17.7652 10.692 17.7637C10.6611 17.7638 11.2443 17.7249 11.1639 17.7495C11.1545 17.6963 11.1451 17.674 11.1618 17.6247C11.2259 17.6317 11.2845 17.664 11.3443 17.691L11.3566 17.6595C13.2368 18.3237 15.332 17.7959 16.6731 16.3203Z" fill="#FF8802"/><path d="M16.6732 16.3203C16.6329 16.6582 15.7605 17.1014 15.5286 17.3558C15.5201 17.5387 16.3359 17.9845 16.5029 18.0985C17.3161 18.6533 18.4334 19.4663 18.832 20.3963C18.8883 20.3684 18.9849 20.2933 19.0348 20.2819C19.2524 20.2319 19.3835 19.99 19.587 19.9807C18.7967 20.7212 17.3857 20.8445 16.3421 20.8587C16.3294 20.8578 16.3167 20.8569 16.304 20.856C16.1671 20.8421 16.0544 20.8397 15.9181 20.8373C16.0248 20.7824 16.5229 20.8529 16.5896 20.7413C16.3993 20.6196 16.3608 20.466 16.2302 20.3609C15.336 19.6351 14.2876 19.1968 13.2541 18.7237C12.0864 18.1892 10.8751 18.0208 9.60059 18.1503C9.29513 18.1814 8.9005 18.1338 8.60554 18.1797C8.09282 18.2595 7.5409 18.3292 7.03335 18.4318C6.77071 18.4842 6.51222 18.5558 6.26002 18.6459C6.08846 18.7065 5.82592 18.8146 5.65746 18.8487C5.58805 18.7927 5.49754 18.6425 5.50481 18.5531C5.57966 18.5065 5.62456 18.5165 5.70142 18.4813C6.16669 18.2685 6.66064 18.1814 7.16097 18.1026C7.41785 18.0584 7.65462 17.9922 7.91428 17.9547C8.82437 17.8235 9.77373 17.7652 10.6921 17.7637C10.6613 17.7638 11.2444 17.7249 11.164 17.7495C11.1546 17.6963 11.1452 17.674 11.162 17.6247C11.226 17.6317 11.2847 17.664 11.3445 17.691L11.3567 17.6595C13.2369 18.3237 15.3321 17.7959 16.6732 16.3203Z" fill="#FF5B0E"/><path d="M5.09928 11.6758C5.11634 11.7871 5.13469 12.0446 5.17803 12.1206L5.23391 12.1288L5.27781 12.0887C5.59187 11.8043 7.43854 11.9457 7.93209 11.9334C8.02074 11.9312 8.05081 12.0099 8.1521 12.0002C7.6592 14.422 9.02641 16.8366 11.3567 17.6597L11.3444 17.6913C11.2846 17.6642 11.226 17.6319 11.1619 17.625C11.1451 17.6742 11.1545 17.6965 11.1639 17.7497C11.2443 17.7252 10.6612 17.764 10.692 17.764C9.77365 17.7655 8.82429 17.8238 7.9142 17.955C7.65455 17.9924 7.41777 18.0587 7.16089 18.1028C6.66056 18.1817 6.16662 18.2688 5.70134 18.4816C5.62448 18.5167 5.57959 18.5067 5.50473 18.5533C5.46897 18.4318 5.41237 18.2578 5.32572 18.1676C5.03561 17.383 5.07591 12.7589 5.09928 11.6758Z" fill="#FF3821"/><path d="M10.7298 10.717C11.4917 9.95278 12.5862 9.62159 13.6441 9.83513C14.7018 10.0487 15.5823 10.7785 15.9881 11.7784C16.5939 13.2709 16.0024 14.9812 14.604 15.7806C13.2057 16.58 11.4318 16.2219 10.453 14.9427C9.47429 13.6635 9.59257 11.8576 10.7298 10.717Z" fill="#FF0D58"/><path d="M10.7298 10.717C11.4918 9.95278 12.5862 9.62159 13.6441 9.83513C14.7019 10.0487 15.5824 10.7785 15.9882 11.7784C15.9506 11.8189 15.908 11.8554 15.8667 11.8924L15.8192 11.8835L15.7945 11.818C15.6597 11.8095 15.6288 11.9711 15.3006 11.9209C13.7008 11.6762 11.9975 11.3281 10.3755 11.2844C10.4736 11.0719 10.6005 10.9506 10.7433 10.7733L10.7298 10.717Z" fill="#FE0480"/></svg>';
  var X_SVG =
    '<svg aria-hidden="true" width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.110216 0.016562C0.486621 0.00307611 0.874505 0.0045908 1.25142 0.00783886C3.43849 0.0266826 5.63408 -0.0208865 7.82022 0.0118285C7.97442 0.25824 8.31252 0.684162 8.49521 0.928837L9.80161 2.67831C11.3178 4.70869 12.8905 6.7671 14.3785 8.81336L22.4977 0.0235044C22.7686 -0.00212623 23.1383 0.00614618 23.416 0.00688099L24.7927 0.0119637C24.5015 0.29888 24.1947 0.645122 23.9139 0.94874L22.4398 2.54379L17.8079 7.55588C17.0312 8.39614 16.1883 9.35189 15.3917 10.1614L22.4614 19.6337L24.7711 22.7275C25.0873 23.1513 25.6678 23.9767 26 24.3488L24.4837 24.3511C22.4285 24.3518 20.2897 24.3838 18.2416 24.3473C18.0449 24.0421 17.7017 23.6088 17.4772 23.3084L16.093 21.456C14.4466 19.2515 12.7328 17.0105 11.1194 14.7883C10.8589 15.1034 10.4336 15.5364 10.1496 15.8435L8.24835 17.9L2.29182 24.3475C1.58148 24.375 0.718631 24.3504 0 24.3486C0.374616 23.9871 0.789696 23.5151 1.1499 23.1249L3.04167 21.0771L7.60665 16.1371C8.43521 15.2404 9.27128 14.3145 10.1121 13.4319C9.99059 13.3069 9.54778 12.6895 9.42228 12.5214L7.95118 10.5514L2.88779 3.77014L0.933267 1.15246C0.811333 0.989268 0.1507 0.143577 0.110216 0.016562Z" fill="white"/><path d="M3.44238 1.68538C3.79805 1.699 4.25769 1.6855 4.62298 1.68525L6.97128 1.68164C7.1993 2.03171 7.62846 2.57052 7.88644 2.91604L9.71419 5.36352L18.3242 16.8934L21.1735 20.7096C21.3027 20.8825 22.6112 22.6062 22.6114 22.676C22.3301 22.6546 21.7645 22.674 21.4587 22.6742L19.0842 22.6774C18.9637 22.4831 18.7482 22.2106 18.6071 22.0215L17.766 20.8951L15.0627 17.2746L6.54903 5.87367L4.26603 2.81657C4.16223 2.67752 3.48649 1.79053 3.44238 1.68538Z" fill="black"/></svg>';
  /* TikTok and Instagram have no web share intent: where the native share
     sheet isn't available the caption is copied and `home` opened so it
     can be pasted into a new post */
  var SHARE_PLATFORMS = [
    { key: 'tiktok', label: 'Share on TikTok', svg: TIKTOK_SVG, home: 'https://www.tiktok.com/upload' },
    { key: 'instagram', label: 'Share on Instagram', svg: INSTAGRAM_SVG, home: 'https://www.instagram.com/' },
    { key: 'x', label: 'Share on X', svg: X_SVG }
  ];
  /* phones / tablets, where the native share sheet lists the TikTok and
     Instagram apps (desktop browsers also implement navigator.share, but
     their OS sheets don't reach those apps) */
  function isMobileDevice() {
    return (
      /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
      (navigator.maxTouchPoints > 1 && /Macintosh/.test(navigator.userAgent))
    );
  }

  /* the result screen's aurora glow — markup lives in the astrek-aurora
     snippet, which the Lab section renders inert in <template data-astrek-aurora> */
  var AURORA_SVG = (function () {
    var tpl = document.querySelector('template[data-astrek-aurora]');
    return tpl ? tpl.innerHTML : '';
  })();

  /* Seeded (deterministic) shuffle — four orders alternate in a 2×2 tile
     pattern so panning wraps invisibly. */
  function shuffledOrder(seed, count) {
    var idx = [];
    for (var i = 0; i < count; i++) idx.push(i);
    var s = seed * 9301 + 49297;
    var rnd = function () {
      s = (s * 9301 + 49297) % 233280;
      return s / 233280;
    };
    for (var j = count - 1; j > 0; j--) {
      var k = Math.floor(rnd() * (j + 1));
      var t = idx[j];
      idx[j] = idx[k];
      idx[k] = t;
    }
    return idx;
  }

  function init() {
    var root = document.getElementById('astrek-lab');
    if (!root || root.dataset.axInit || typeof gsap === 'undefined' || !window.AstrekQuiz) return;
    root.dataset.axInit = '1';

    var Q = window.AstrekQuiz;
    var questions = Q.questions;
    var archetypes = Q.archetypes;
    var esc = Q.escapeHtml;

    var config = {};
    var cfgEl = root.querySelector('[data-astrek-lab-config]');
    if (cfgEl) {
      try {
        config = JSON.parse(cfgEl.textContent);
      } catch (e) {
        config = {};
      }
    }
    var assets = config.assets || {};
    var resultImgs = assets.results || {};
    var shareImgs = assets.shares || {};
    var discordUrl = config.discordUrl || '#';
    /* where a shared result links to: {key} = archetype key, {handle} = lowercased */
    var sharePageUrl = config.sharePageUrl || '/pages/share?result={key}';

    /* resolve card backgrounds (image-backed entries need asset URLs) */
    var backgrounds = Q.cardBackgrounds.map(function (b) {
      if (b.bgAsset && assets[b.bgAsset]) {
        return {
          bg: "url('" + assets[b.bgAsset] + "') center / cover no-repeat, " + b.bgColor,
          base: b.base
        };
      }
      return { bg: b.bg || b.bgColor, base: b.base };
    });
    function bgFor(q) {
      return backgrounds[q % backgrounds.length];
    }

    var viewport = root.querySelector('[data-board-viewport]');
    var canvas = root.querySelector('[data-board-canvas]');
    if (!viewport || !canvas) return;

    var modalOpen = false;

    /* ================= board ================= */

    var tileOrders = [1, 2, 3, 4].map(function (seed) {
      return shuffledOrder(seed, questions.length);
    });

    function tileHTML(order) {
      var html = '';
      order.forEach(function (q, slotIdx) {
        var slot = BOARD_SLOTS[slotIdx % BOARD_SLOTS.length];
        html +=
          '<button type="button" class="ax-tile__card" data-board-card data-q="' + q + '" ' +
          'style="top:' + slot.top + '%;left:' + slot.left + '%;--cw:' + BOARD_CARD_W + '%" ' +
          'aria-label="Open question ' + (q + 1) + '">' +
          Q.cardArtHTML({ teaser: questions[q].text, bg: bgFor(q).bg, base: bgFor(q).base }) +
          '</button>';
      });
      return html;
    }

    /* 4×4 grid of tiles; orders repeat every 2 tiles, panning wraps by that
       2-tile period, which is invisible because the pattern repeats exactly. */
    var tileEl = null;
    for (var k = 0; k < 16; k++) {
      var row = Math.floor(k / 4);
      var col = k % 4;
      var tile = document.createElement('div');
      tile.className = 'ax-tile';
      if (k === 5) tile.setAttribute('data-mid', '');
      else tile.setAttribute('aria-hidden', 'true');
      tile.innerHTML = tileHTML(tileOrders[(row % 2) * 2 + (col % 2)]);
      canvas.appendChild(tile);
      if (k === 0) tileEl = tile;
    }
    var loading = root.querySelector('[data-board-loading]');
    if (loading) loading.remove();

    canvas.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-board-card]');
      if (btn) openModal(parseInt(btn.getAttribute('data-q'), 10), null);
    });

    /* intro */
    gsap.from(root.querySelectorAll('[data-mid] [data-board-card]'), {
      opacity: 0,
      scale: 0.7,
      y: 40,
      duration: 0.7,
      ease: 'back.out(1.5)',
      stagger: { each: 0.04, from: 'random' },
      delay: 0.15
    });
    gsap.from(root.querySelectorAll('[data-board-hint]'), { opacity: 0, y: 12, duration: 0.8, delay: 1 });

    /* ---------- pan / zoom ---------- */
    var pan = { x: 0, y: 0 };
    var scale = 1;

    function period() {
      return { w: tileEl.offsetWidth * 2 * scale, h: tileEl.offsetHeight * 2 * scale };
    }
    function norm(v, t) {
      return -t + (((v % t) + t) % t);
    }
    function apply(x, y) {
      var p = period();
      pan = { x: norm(x, p.w), y: norm(y, p.h) };
      gsap.set(canvas, { x: pan.x, y: pan.y });
    }

    /* start zoomed out, centered on the middle tile (phones get a
       closer view so the cards read at a glance) */
    scale = window.matchMedia('(min-width: 1024px)').matches ? 0.65 : 0.9;
    gsap.set(canvas, { transformOrigin: '0 0', scale: scale });
    apply(
      viewport.clientWidth / 2 - 1.5 * tileEl.offsetWidth * scale,
      viewport.clientHeight / 2 - 1.5 * tileEl.offsetHeight * scale
    );

    /* pinch-zoom, anchored at the cursor (canvas transform-origin is 0 0) */
    function zoomAt(clientX, clientY, nextRaw) {
      var old = scale;
      var next = gsap.utils.clamp(0.4, 2.5, nextRaw);
      if (next === old) return;
      var rect = viewport.getBoundingClientRect();
      var cx = clientX - rect.left;
      var cy = clientY - rect.top;
      var ratio = next / old;
      var nx = cx - (cx - pan.x) * ratio;
      var ny = cy - (cy - pan.y) * ratio;
      scale = next;
      gsap.set(canvas, { scale: next });
      apply(nx, ny);
    }

    /* pointer drag — infinite, wrapping. Pointer capture is only taken once
       the pointer actually moves; capturing on pointerdown would retarget
       the click to the viewport and card taps would never open. */
    var dragging = false;
    var dragged = false;
    var start = { x: 0, y: 0 };
    var last = { x: 0, y: 0 };

    viewport.addEventListener('pointerdown', function (e) {
      if (modalOpen || !e.isPrimary) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      dragged = false;
      start = last = { x: e.clientX, y: e.clientY };
      e.preventDefault();
    });
    viewport.addEventListener('pointermove', function (e) {
      if (!dragging || !e.isPrimary) return;
      if (!dragged) {
        if (Math.hypot(e.clientX - start.x, e.clientY - start.y) <= 5) return;
        dragged = true;
        viewport.setPointerCapture(e.pointerId);
        canvas.style.cursor = 'grabbing';
        last = { x: e.clientX, y: e.clientY };
        return;
      }
      var dx = e.clientX - last.x;
      var dy = e.clientY - last.y;
      last = { x: e.clientX, y: e.clientY };
      apply(pan.x + dx, pan.y + dy);
    });
    function onUp() {
      dragging = false;
      canvas.style.cursor = '';
    }
    viewport.addEventListener('pointerup', onUp);
    viewport.addEventListener('pointercancel', onUp);
    /* swallow the click that follows a drag so cards don't open */
    viewport.addEventListener(
      'click',
      function (e) {
        if (dragged) {
          e.preventDefault();
          e.stopPropagation();
          dragged = false;
        }
      },
      true
    );

    /* wheel / trackpad: pan (wrapping) or pinch-zoom (ctrl+wheel) */
    viewport.addEventListener(
      'wheel',
      function (e) {
        if (modalOpen) return;
        e.preventDefault();
        if (e.ctrlKey) {
          zoomAt(e.clientX, e.clientY, scale * Math.exp(-e.deltaY * 0.012));
          return;
        }
        var unit = e.deltaMode === 1 ? 16 : 1; // Firefox line-mode
        var dx = (e.shiftKey && e.deltaX === 0 ? e.deltaY : e.deltaX) * unit;
        var dy = (e.shiftKey && e.deltaX === 0 ? 0 : e.deltaY) * unit;
        apply(pan.x - dx, pan.y - dy);
      },
      { passive: false }
    );

    /* Safari fires proprietary gesture events for trackpad pinch */
    var gestureBase = 1;
    viewport.addEventListener('gesturestart', function (e) {
      e.preventDefault();
      gestureBase = scale;
    });
    viewport.addEventListener('gesturechange', function (e) {
      e.preventDefault();
      if (modalOpen) return;
      zoomAt(
        e.clientX != null ? e.clientX : viewport.clientWidth / 2,
        e.clientY != null ? e.clientY : viewport.clientHeight / 2,
        gestureBase * (e.scale != null ? e.scale : 1)
      );
    });

    /* ================= quiz modal ================= */

    function computeResult(all) {
      var score = {};
      var lastSeq = {};
      Object.keys(all).forEach(function (k) {
        var a = all[k];
        score[a.archetype] = (score[a.archetype] || 0) + 2;
        lastSeq[a.archetype] = Math.max(lastSeq[a.archetype] || 0, a.seq);
      });
      var best = null;
      Object.keys(score).forEach(function (k) {
        if (!best || score[k] > score[best] || (score[k] === score[best] && lastSeq[k] > lastSeq[best]))
          best = k;
      });
      return archetypes[best || 'lineHunter'];
    }

    function openModal(startIndex, debugResult) {
      if (modalOpen) return;
      modalOpen = true;

      var len = questions.length;
      var order = questions.map(function (_, i) {
        return (startIndex + i) % len;
      });
      var pos = 0;
      var answers = {};
      var result = debugResult ? archetypes[debugResult] : null;
      var seq = 0;
      var switching = false;
      var dir = 1;
      var firstCard = true;
      var cardEls = new Map();
      var frontEl = null;
      var cardFile = null; /* share graphic, prefetched for the native share sheet / download */
      var shareNoteTimer = null;
      var floatTween = null;

      var modal = document.createElement('div');
      modal.className = 'ax-quiz';
      document.body.appendChild(modal);

      /* ---------- close / keyboard ---------- */
      function close() {
        gsap.to(modal, {
          opacity: 0,
          duration: 0.35,
          onComplete: function () {
            modal.remove();
            window.removeEventListener('keydown', onKey);
            modalOpen = false;
          }
        });
      }
      function onKey(e) {
        if (e.key === 'Escape') close();
        else if (result) return;
        else if (e.key === 'ArrowLeft') step(-1);
        else if (e.key === 'ArrowRight') step(1);
      }
      window.addEventListener('keydown', onKey);

      /* ---------- deck navigation ---------- */
      function goTo(target, d) {
        if (switching) return;
        switching = true;
        dir = d;
        if (d === 1 && frontEl) {
          var el = frontEl;
          gsap.to(el, {
            xPercent: -60,
            rotate: -12,
            opacity: 0,
            duration: 0.28,
            ease: 'power2.in',
            onComplete: function () {
              pos = target;
              update();
            }
          });
        } else {
          pos = target;
          update();
        }
      }
      function step(d) {
        goTo((pos + d + len) % len, d);
      }

      /* ---------- question screen ---------- */
      var tiltEl, deckEl, glareEl, panelEl, questionHost;

      /* intro: play the modal fade + stack/panel/nav entrance (first open
         only — a retake just resets state, like the Next component) */
      function renderQuestionScreen(intro) {
        cardEls.clear();
        frontEl = null;
        modal.innerHTML =
          '<div class="ax-quiz__qwrap">' +
          '<button type="button" class="ax-quiz__close" data-close aria-label="Close">' + CLOSE_SVG + '</button>' +
          '<div class="ax-quiz__deck" data-deck>' +
          '<div class="ax-quiz__stack" data-stack>' +
          '<div class="ax-quiz__tilt" data-tilt></div>' +
          '<div class="ax-quiz__nav" data-deck-nav>' +
          '<button type="button" class="ax-quiz__navbtn ax-quiz__navbtn--prev" data-prev aria-label="Previous question">' + ARROW_SVG + '</button>' +
          '<button type="button" class="ax-quiz__navbtn ax-quiz__navbtn--next" data-next aria-label="Next question">' + ARROW_SVG + '</button>' +
          '</div></div></div>' +
          '<div class="ax-quiz__panel" data-quiz-panel><div data-question-host></div></div>' +
          '</div>';

        deckEl = modal.querySelector('[data-deck]');
        tiltEl = modal.querySelector('[data-tilt]');
        panelEl = modal.querySelector('[data-quiz-panel]');
        questionHost = modal.querySelector('[data-question-host]');

        modal.querySelector('[data-close]').addEventListener('click', close);
        modal.querySelector('[data-prev]').addEventListener('click', function () {
          step(-1);
        });
        modal.querySelector('[data-next]').addEventListener('click', function () {
          step(1);
        });

        wireDeck();
        update();

        if (intro) {
          var tl = gsap.timeline();
          tl.fromTo(modal, { opacity: 0 }, { opacity: 1, duration: 0.35 });
          tl.fromTo(
            modal.querySelectorAll('[data-stack]'),
            { scale: 0.8, opacity: 0 },
            { scale: 1, opacity: 1, stagger: 0.08, duration: 0.65, ease: 'back.out(1.4)' },
            '-=0.1'
          );
          tl.fromTo(panelEl, { x: 60, opacity: 0 }, { x: 0, opacity: 1, duration: 0.6, ease: 'power3.out' }, '-=0.5');
          tl.fromTo(
            modal.querySelectorAll('[data-deck-nav]'),
            { opacity: 0, y: 10 },
            { opacity: 1, y: 0, duration: 0.4 },
            '-=0.4'
          );
        }
      }

      function cardSlotEl(q) {
        var el = cardEls.get(q);
        if (el) return el;
        el = document.createElement('div');
        el.className = 'ax-quiz__cardslot';
        el.innerHTML =
          '<div class="ax-quiz__cardinner">' +
          Q.cardArtHTML({
            num: String(q + 1).padStart(2, '0'),
            teaser: questions[q].text,
            bg: bgFor(q).bg,
            base: bgFor(q).base
          }) +
          '<div class="ax-quiz__glare"></div>' +
          '</div>';
        tiltEl.appendChild(el);
        cardEls.set(q, el);
        return el;
      }

      /* Arrange the three visible cards into their stack slots. Cards that
         stay visible keep their DOM node (keyed by question) and glide from
         their old slot to the new one; fresh cards enter from the direction
         of travel. */
      function arrange() {
        var visible = {};
        for (var d = 0; d < 3; d++) {
          var q = order[(pos + d) % len];
          visible[q] = true;
          var el = cardSlotEl(q);
          var slot = DECK_SLOTS[d];
          var done =
            d === 0
              ? function () {
                  switching = false;
                }
              : undefined;
          if (firstCard) {
            gsap.set(el, slot);
          } else if (el.dataset.deckInit) {
            gsap.to(el, {
              xPercent: slot.xPercent,
              yPercent: slot.yPercent,
              rotate: slot.rotate,
              scale: slot.scale,
              zIndex: slot.zIndex,
              x: 0,
              y: 0,
              opacity: 1,
              duration: 0.55,
              ease: 'power3.out',
              overwrite: 'auto',
              onComplete: done
            });
          } else {
            var from =
              dir === 1
                ? { xPercent: 30, yPercent: -22, rotate: 9, scale: 0.9, zIndex: slot.zIndex, opacity: 0 }
                : { xPercent: -60, yPercent: 4, rotate: -12, scale: 0.97, zIndex: slot.zIndex, opacity: 0 };
            gsap.fromTo(el, from, {
              xPercent: slot.xPercent,
              yPercent: slot.yPercent,
              rotate: slot.rotate,
              scale: slot.scale,
              zIndex: slot.zIndex,
              x: 0,
              y: 0,
              opacity: 1,
              duration: 0.55,
              ease: 'power3.out',
              onComplete: done
            });
          }
          el.dataset.deckInit = '1';
        }
        /* drop cards that left the visible stack */
        cardEls.forEach(function (el, q) {
          if (!visible[q]) {
            gsap.killTweensOf(el);
            el.remove();
            cardEls.delete(q);
          }
        });
        frontEl = cardEls.get(order[pos]) || null;
        glareEl = frontEl ? frontEl.querySelector('.ax-quiz__glare') : null;
        if (firstCard) switching = false;
        firstCard = false;
      }

      function renderQuestion() {
        var qIndex = order[pos];
        var question = questions[qIndex];
        var answer = answers[qIndex];
        var html =
          '<p class="ax-quiz__qnum" data-q-reveal>' +
          '<span>Question ' + (qIndex + 1) + '</span>' +
          '<span class="ax-quiz__qcount">' + (pos + 1) + ' / ' + len + '</span>' +
          '</p>' +
          '<h2 class="ax-quiz__qtext" data-q-reveal>' + esc(question.text) + '</h2>' +
          '<div class="ax-quiz__opts">';
        question.options.forEach(function (o) {
          var checked = answer && answer.key === o.key;
          html +=
            '<label class="ax-quiz__opt' +
            (answer ? ' is-locked' : '') +
            (checked ? ' is-checked' : '') +
            '" data-q-reveal>' +
            '<input type="radio" name="ax-q-' + qIndex + '" value="' + o.key + '"' +
            (checked ? ' checked' : '') +
            (answer ? ' disabled' : '') +
            '>' +
            '<span class="ax-quiz__radio"><span class="ax-quiz__radiodot"></span></span>' +
            '<span>' + esc(o.label) + '</span>' +
            '</label>';
        });
        html +=
          '</div><div class="ax-quiz__answered-row">' +
          (answer ? '<span>Answered — keep exploring for the next one</span>' : '') +
          '</div>';
        questionHost.innerHTML = html;

        questionHost.querySelectorAll('input[type="radio"]').forEach(function (input) {
          input.addEventListener('change', function () {
            chooseAnswer(input.value);
          });
        });

        gsap.fromTo(
          questionHost.querySelectorAll('[data-q-reveal]'),
          { x: 40, opacity: 0 },
          { x: 0, opacity: 1, stagger: 0.07, duration: 0.5, ease: 'power2.out' }
        );
      }

      function update() {
        arrange();
        renderQuestion();
      }

      /* choosing an option records it and advances to the next question */
      function chooseAnswer(key) {
        var qIndex = order[pos];
        if (answers[qIndex] || switching) return;
        var opt = null;
        questions[qIndex].options.forEach(function (o) {
          if (o.key === key) opt = o;
        });
        if (!opt) return;
        seq += 1;
        answers[qIndex] = { key: key, archetype: opt.archetype, seq: seq };

        /* lock the options in place */
        questionHost.querySelectorAll('.ax-quiz__opt').forEach(function (label) {
          label.classList.add('is-locked');
          var input = label.querySelector('input');
          if (input.value === key) label.classList.add('is-checked');
          input.disabled = true;
        });
        var row = questionHost.querySelector('.ax-quiz__answered-row');
        if (row) row.innerHTML = '<span>Answered — keep exploring for the next one</span>';

        if (Object.keys(answers).length >= len) {
          window.setTimeout(function () {
            showResult(computeResult(answers));
          }, 450);
          return;
        }
        window.setTimeout(function () {
          for (var s = 1; s <= len; s++) {
            var p = (pos + s) % len;
            if (!answers[order[p]]) {
              goTo(p, 1);
              return;
            }
          }
        }, 350);
      }

      /* ---------- deck drag / tilt / swipe ---------- */
      function wireDeck() {
        var mouseDrag = null;
        var touchStart = null;

        deckEl.addEventListener('mousedown', function (e) {
          if (e.button !== 0) return;
          mouseDrag = { x: e.clientX, y: e.clientY };
          e.preventDefault();
        });

        function endMouseDrag(e) {
          var st = mouseDrag;
          mouseDrag = null;
          if (!st) return;
          var dx = e.clientX - st.x;
          var dy = e.clientY - st.y;
          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) {
            step(dx < 0 ? 1 : -1);
          } else if (frontEl && !switching) {
            gsap.to(frontEl, { x: 0, rotate: 0, duration: 0.3, ease: 'power2.out' });
          }
        }
        deckEl.addEventListener('mouseup', endMouseDrag);

        deckEl.addEventListener('mousemove', function (e) {
          /* while dragging, the card follows the cursor instead of tilting */
          if (mouseDrag) {
            if (!frontEl || switching) return;
            gsap.set(frontEl, { x: (e.clientX - mouseDrag.x) * 0.35, rotate: (e.clientX - mouseDrag.x) * 0.03 });
            return;
          }
          if (!tiltEl) return;
          var r = tiltEl.getBoundingClientRect();
          var px = gsap.utils.clamp(-0.6, 0.6, (e.clientX - (r.left + r.width / 2)) / r.width);
          var py = gsap.utils.clamp(-0.6, 0.6, (e.clientY - (r.top + r.height / 2)) / r.height);
          gsap.to(tiltEl, {
            rotationY: px * 14,
            rotationX: -py * 10,
            transformPerspective: 900,
            duration: 0.5,
            ease: 'power2.out',
            overwrite: 'auto'
          });
          if (glareEl)
            gsap.to(glareEl, {
              opacity: 0.5,
              x: px * r.width * 0.8,
              y: py * r.height * 0.8,
              duration: 0.5,
              ease: 'power2.out',
              overwrite: 'auto'
            });
        });

        deckEl.addEventListener('mouseleave', function (e) {
          endMouseDrag(e);
          if (tiltEl)
            gsap.to(tiltEl, { rotationY: 0, rotationX: 0, duration: 0.7, ease: 'power3.out', overwrite: 'auto' });
          if (glareEl) gsap.to(glareEl, { opacity: 0, x: 0, y: 0, duration: 0.6, overwrite: 'auto' });
        });

        deckEl.addEventListener('touchstart', function (e) {
          var t = e.touches[0];
          touchStart = { x: t.clientX, y: t.clientY };
        });
        deckEl.addEventListener('touchmove', function (e) {
          if (!touchStart || !frontEl || switching) return;
          var t = e.touches[0];
          var dx = t.clientX - touchStart.x;
          gsap.set(frontEl, { x: dx * 0.35, rotate: dx * 0.03 });
        });
        deckEl.addEventListener('touchend', function (e) {
          var st = touchStart;
          touchStart = null;
          if (!st) return;
          var t = e.changedTouches[0];
          var dx = t.clientX - st.x;
          var dy = t.clientY - st.y;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
            step(dx < 0 ? 1 : -1);
          } else if (frontEl && !switching) {
            gsap.to(frontEl, { x: 0, rotate: 0, duration: 0.3, ease: 'power2.out' });
          }
        });
      }

      /* ---------- result screen ---------- */
      function showResult(a) {
        result = a;
        var img = resultImgs[a.key] || '';
        modal.innerHTML =
          '<div class="ax-quiz__result">' +
          '<div class="ax-quiz__aurora" aria-hidden="true">' + AURORA_SVG + '</div>' +
          '<button type="button" class="ax-quiz__close" data-close aria-label="Close">' + CLOSE_SVG + '</button>' +
          '<h2 class="ax-quiz__rtitle" data-q-reveal>Your Mountain Character</h2>' +
          '<div class="ax-quiz__rhit" data-rhit data-q-reveal>' +
          '<div class="ax-quiz__rcard" data-rcard>' +
          '<div class="ax-quiz__rface">' +
          '<img src="' + esc(img) + '" alt="' + esc(a.name) + '" draggable="false">' +
          '<div class="ax-quiz__rglare" data-rglare></div>' +
          '</div>' +
          '<div class="ax-quiz__rface ax-quiz__rback" aria-hidden="true">' +
          '<img src="' + esc(img) + '" alt="" draggable="false">' +
          '</div>' +
          (function () {
            /* card thickness: a solid wall around the perimeter — four
               straight edge planes plus 8 small facets per rounded
               corner, so the side view is one continuous surface */
            var edge = a.edgeColor || '#dcdcdc';
            var R = 26; /* corner radius */
            var D = 12; /* card thickness */
            var SW = 7; /* corner facet width (chord + overlap) */
            var N = 8; /* facets per corner */
            function plane(styles) {
              return (
                '<div class="ax-quiz__redge" aria-hidden="true" style="' +
                styles + 'background:' + edge + '"></div>'
              );
            }
            var html =
              plane('left:' + -D / 2 + 'px;top:' + R + 'px;bottom:' + R + 'px;width:' + D + 'px;transform:rotateY(90deg);') +
              plane('right:' + -D / 2 + 'px;top:' + R + 'px;bottom:' + R + 'px;width:' + D + 'px;transform:rotateY(90deg);') +
              plane('top:' + -D / 2 + 'px;left:' + R + 'px;right:' + R + 'px;height:' + D + 'px;transform:rotateX(90deg);') +
              plane('bottom:' + -D / 2 + 'px;left:' + R + 'px;right:' + R + 'px;height:' + D + 'px;transform:rotateX(90deg);');
            var cornerDefs = [
              ['left', 'top', 180],
              ['right', 'top', 270],
              ['right', 'bottom', 0],
              ['left', 'bottom', 90]
            ];
            cornerDefs.forEach(function (c) {
              for (var fi = 0; fi < N; fi++) {
                var deg = c[2] + (fi + 0.5) * (90 / N);
                var th = (deg * Math.PI) / 180;
                var h = R * (1 + (c[0] === 'left' ? Math.cos(th) : -Math.cos(th))) - SW / 2;
                var v = R * (1 + (c[1] === 'top' ? Math.sin(th) : -Math.sin(th))) - D / 2;
                html += plane(
                  c[0] + ':' + h.toFixed(2) + 'px;' + c[1] + ':' + v.toFixed(2) + 'px;' +
                  'width:' + SW + 'px;height:' + D + 'px;' +
                  'transform:rotate(' + (deg + 90) + 'deg) rotateX(90deg);'
                );
              }
            });
            return html;
          })() +
          '</div>' +
          '</div>' +
          '<div class="ax-quiz__ractions" data-q-reveal>' +
          '<button type="button" class="ax-quiz__share" data-share>Share</button>' +
          '<a class="ax-quiz__discord" href="' + esc(discordUrl) + '" target="_blank" rel="noopener">' + DISCORD_SVG + 'Join ASTREK Discord</a>' +
          '</div>' +
          '<button type="button" class="ax-quiz__retake" data-retake data-q-reveal>Explore again</button>' +
          /* share → pick a platform: overlays the (hidden) result body */
          '<div class="ax-quiz__sharepick" data-sharepick hidden>' +
          SHARE_PLATFORMS.map(function (p) {
            return (
              '<button type="button" class="ax-quiz__platform" data-platform="' + p.key + '" data-share-reveal>' +
              p.svg + '<span>' + p.label + '</span></button>'
            );
          }).join('') +
          '<p class="ax-quiz__sharenote" data-sharenote data-share-reveal aria-live="polite"></p>' +
          '<button type="button" class="ax-quiz__shareback" data-shareback data-share-reveal>Back</button>' +
          '</div>' +
          '</div>';

        modal.querySelector('[data-close]').addEventListener('click', close);
        modal.querySelector('[data-retake]').addEventListener('click', retake);
        modal.querySelector('[data-share]').addEventListener('click', openShare);
        modal.querySelector('[data-shareback]').addEventListener('click', closeShare);
        modal.querySelectorAll('[data-platform]').forEach(function (b) {
          b.addEventListener('click', function () {
            shareTo(b.getAttribute('data-platform'));
          });
        });

        gsap.fromTo(
          modal.querySelectorAll('[data-q-reveal]'),
          { x: 40, opacity: 0 },
          { x: 0, opacity: 1, stagger: 0.07, duration: 0.5, ease: 'power2.out' }
        );

        var card = modal.querySelector('[data-rcard]');
        var hit = modal.querySelector('[data-rhit]');
        var rglare = modal.querySelector('[data-rglare]');

        /* idle state: the card slowly spins around the Y axis */
        function startFloat() {
          if (floatTween) floatTween.kill();
          gsap.set(card, { transformPerspective: 900 });
          floatTween = gsap.to(card, { rotationY: '+=360', duration: 22, repeat: -1, ease: 'none' });
        }
        startFloat();

        /* hold & drag to spin the card; releasing keeps the momentum
           going, then the idle float takes over again */
        var drag = { active: false, lastX: 0, lastY: 0, lastT: 0, vel: 0, rotX: 0 };

        hit.addEventListener('pointerdown', function (e) {
          if (e.button !== 0) return;
          hit.setPointerCapture(e.pointerId);
          if (floatTween) {
            floatTween.kill();
            floatTween = null;
          }
          gsap.killTweensOf(card);
          drag.active = true;
          drag.lastX = e.clientX;
          drag.lastY = e.clientY;
          drag.lastT = performance.now();
          drag.vel = 0;
          drag.rotX = Number(gsap.getProperty(card, 'rotationX')) || 0;
          hit.style.cursor = 'grabbing';
        });
        hit.addEventListener('pointermove', function (e) {
          if (!drag.active) return;
          var now = performance.now();
          var dx = e.clientX - drag.lastX;
          var dy = e.clientY - drag.lastY;
          var dt = Math.max(1, now - drag.lastT);
          drag.vel = drag.vel * 0.8 + (dx / dt) * 0.2;
          drag.lastX = e.clientX;
          drag.lastY = e.clientY;
          drag.lastT = now;
          /* X tilts up to 90° each way. rotationX is applied in the
             card's local frame (after rotationY), so when the back faces
             the viewer the vertical direction must flip to keep the drag
             screen-true. */
          var rotYNow = Number(gsap.getProperty(card, 'rotationY')) || 0;
          var facing = Math.cos((rotYNow * Math.PI) / 180) < 0 ? 1 : -1;
          drag.rotX = gsap.utils.clamp(-90, 90, drag.rotX + facing * dy * 0.55);
          gsap.set(card, {
            rotationY: '+=' + dx * 0.55,
            rotationX: drag.rotX,
            transformPerspective: 900
          });
          if (rglare) {
            var r = card.getBoundingClientRect();
            var px = (e.clientX - (r.left + r.width / 2)) / r.width;
            var py = (e.clientY - (r.top + r.height / 2)) / r.height;
            gsap.set(rglare, { opacity: 0.4, x: px * r.width * 0.8, y: py * r.height * 0.8 });
          }
        });
        function endCardDrag() {
          if (!drag.active) return;
          drag.active = false;
          hit.style.cursor = '';
          /* momentum decays, then the idle auto-spin takes over again;
             the X tilt stays where the drag left it — no spring-back */
          var fling = gsap.utils.clamp(-3, 3, drag.vel);
          gsap.to(card, {
            rotationY: '+=' + fling * 300,
            duration: 1.1,
            ease: 'power2.out',
            onComplete: startFloat
          });
          if (rglare) gsap.to(rglare, { opacity: 0, x: 0, y: 0, duration: 0.5, overwrite: 'auto' });
        }
        hit.addEventListener('pointerup', endCardDrag);
        hit.addEventListener('pointercancel', endCardDrag);
      }

      /* ---------- share: pick a platform ---------- */
      function openShare() {
        var pick = modal.querySelector('[data-sharepick]');
        if (!result || !pick || !pick.hidden) return;
        var host = modal.querySelector('.ax-quiz__result');
        if (host) host.scrollTop = 0;
        var body = modal.querySelectorAll('[data-q-reveal]');
        var note = modal.querySelector('[data-sharenote]');
        if (note) note.textContent = '';
        pick.hidden = false;
        /* the result body slides away and the platform list takes its place */
        gsap.to(body, {
          opacity: 0,
          y: -14,
          duration: 0.28,
          stagger: 0.03,
          ease: 'power2.in',
          onComplete: function () {
            gsap.set(body, { visibility: 'hidden' });
          }
        });
        gsap.fromTo(
          pick.querySelectorAll('[data-share-reveal]'),
          { x: 40, opacity: 0 },
          { x: 0, opacity: 1, stagger: 0.07, duration: 0.5, ease: 'power2.out', delay: 0.2 }
        );
        /* prefetch the share graphic as a File so the native share sheet can
           be invoked synchronously from the tap */
        cardFile = null;
        var src = shareImgs[result.key] || resultImgs[result.key];
        var key = result.key;
        if (src && window.File && window.fetch) {
          fetch(src)
            .then(function (r) {
              return r.blob();
            })
            .then(function (blob) {
              cardFile = new File([blob], 'astrek-share-' + key + '.png', { type: 'image/png' });
            })
            .catch(function () {});
        }
      }

      function closeShare() {
        var pick = modal.querySelector('[data-sharepick]');
        if (!pick || pick.hidden) return;
        var body = modal.querySelectorAll('[data-q-reveal]');
        gsap.to(pick.querySelectorAll('[data-share-reveal]'), {
          x: -30,
          opacity: 0,
          duration: 0.25,
          stagger: 0.03,
          ease: 'power2.in',
          onComplete: function () {
            pick.hidden = true;
            /* coming back replays the body's reveal */
            gsap.set(body, { visibility: 'visible' });
            gsap.fromTo(
              body,
              { opacity: 0, y: 14 },
              { opacity: 1, y: 0, stagger: 0.05, duration: 0.45, ease: 'power2.out', overwrite: 'auto' }
            );
          }
        });
      }

      function showShareNote(msg) {
        var note = modal.querySelector('[data-sharenote]');
        if (!note) return;
        note.textContent = msg;
        if (shareNoteTimer) window.clearTimeout(shareNoteTimer);
        shareNoteTimer = window.setTimeout(function () {
          if (note.isConnected) note.textContent = '';
        }, 3000);
      }

      /* the shared link lands on the share page for this result (its
         share graphic, with the link preview to match) */
      function shareUrlFor(key) {
        var path = sharePageUrl.replace('{key}', key).replace('{handle}', key.toLowerCase());
        return new URL(path, window.location.href).toString();
      }

      /* saves the share graphic (desktop TikTok / Instagram, where the image
         has to be uploaded by hand). The CDN image is cross-origin, so this
         needs the prefetched blob; returns false if it isn't there. */
      function downloadCard(key) {
        if (!cardFile) return false;
        var a = document.createElement('a');
        a.href = URL.createObjectURL(cardFile);
        a.download = 'astrek-share-' + key + '.png';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.setTimeout(function () {
          URL.revokeObjectURL(a.href);
        }, 10000);
        return true;
      }

      function shareTo(platform) {
        if (!result) return;
        var text = 'My Mountain Character: ' + result.name + ' — “' + result.tagline + '” · ASTREK';
        var url = shareUrlFor(result.key);
        if (platform === 'x') {
          window.open(
            'https://x.com/intent/post?text=' + encodeURIComponent(text) + '&url=' + encodeURIComponent(url),
            '_blank',
            'noopener,noreferrer'
          );
          return;
        }
        /* phones: hand the card image to the native share sheet, where the
           user picks the TikTok / Instagram app */
        if (cardFile && isMobileDevice() && navigator.canShare && navigator.canShare({ files: [cardFile] })) {
          navigator.share({ files: [cardFile], title: 'ASTREK', text: text + ' ' + url }).catch(function () {});
          return;
        }
        /* elsewhere: save the card image and copy the caption (while this
           document still has focus), then open the platform in a new tab */
        var saved = downloadCard(result.key);
        if (navigator.clipboard) {
          navigator.clipboard
            .writeText(text + ' ' + url)
            .then(function () {
              showShareNote(
                saved
                  ? 'Card image saved & caption copied — add them to your post'
                  : 'Caption copied — paste it into your post'
              );
            })
            .catch(function () {
              if (saved) showShareNote('Card image saved — add it to your post');
            });
        }
        var home = '';
        SHARE_PLATFORMS.forEach(function (p) {
          if (p.key === platform && p.home) home = p.home;
        });
        if (home) window.open(home, '_blank', 'noopener,noreferrer');
      }

      function retake() {
        if (floatTween) {
          floatTween.kill();
          floatTween = null;
        }
        seq = 0;
        answers = {};
        result = null;
        pos = 0;
        switching = false;
        firstCard = false;
        renderQuestionScreen(false);
      }

      /* ---------- open ---------- */
      if (result) {
        showResult(result);
        gsap.fromTo(modal, { opacity: 0 }, { opacity: 1, duration: 0.35 });
      } else {
        firstCard = true;
        renderQuestionScreen(true);
      }
    }

    /* dev helper: ?result opens the result screen directly. Accepts an
       archetype key (?result=gear) or a number 1–8 in the archetypes'
       definition order (?result=5). */
    var params = new URLSearchParams(window.location.search);
    var resultParam = params.get('result');
    if (resultParam !== null) {
      var archKeys = Object.keys(archetypes);
      var key = /^[1-8]$/.test(resultParam) ? archKeys[Number(resultParam) - 1] : resultParam;
      openModal(0, archetypes[key] ? key : 'influencer');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
